<template>
  <section>
    <div class="container bg-gray-200">
      <div class="row mb-2 mb-md-5">
        <div class="col-12 text-center">
          <h1>Votre profil</h1>
        </div>
      </div>
      <transition
        name="fade"
        mode="out-in"
        tag="div"
      >
        <router-view :key="$route.path" />
      </transition>
    </div>
  </section>
</template>

<script>

export default {
  name: 'AccountView',
};
</script>
<style lang="scss" scoped>
.container {
  border-radius: 10px 10px 0px 0px;
  background-color: white;
  height: 100%;
}
</style>
